import * as Models from 'components/framework/models';

interface Opt {
  value: string;
  text: string;
}

type ResolveOptions = (value: string[]) => Promise<Opt[] | undefined>;

const OPTION_MODELS = {
  users: Models.User,
  epics: Models.Epic,
  releases: Models.Release,
  initiatives: Models.Initiative,
  goals: Models.Goal,
  projects: Models.Project,
  idea_themes: Models.IdeaTheme,
  idea_categories: Models.IdeaCategory,
};

// keep track of loaded models to avoid loading each multiple times
const recordMap = new Map<
  string,
  Map<string, InstanceType<(typeof OPTION_MODELS)[keyof typeof OPTION_MODELS]>>
>();

export const optionResolverFactory =
  (recordType: keyof typeof OPTION_MODELS): ResolveOptions =>
  async values => {
    const ModelClass = OPTION_MODELS[recordType];

    if (!recordMap.has(recordType)) {
      recordMap.set(recordType, new Map());
    }
    const typeMap = recordMap.get(recordType)!;

    return Promise.all(
      values.map(async value => {
        let record = typeMap.get(value);
        if (!record) {
          record = (
            await ModelClass.select('id', 'name').where({ id: value }).all()
          )[0];
          typeMap.set(value, record);
          record.reactive({});
        }

        return {
          value,
          text: record.name,
        };
      })
    );
  };
